import styled from "styled-components";

export const CheckboxesContainer = styled("div")`
   display: flex;
   flex-direction: column;
   padding: 8px;
   width: 200px;
   row-gap: 4px;
`;
